
export class Timezone {
  timezoneId: any;
  code: string;
  name: string;
  isProctor: boolean;
  offset: number;
  systemName: string;

  constructor(
    timezoneId?: any,
    code?: string,
    name?: string,
    isProctor?: boolean,
    offset?: number,
    systemName?: string
  ) {
    this.timezoneId = timezoneId;
    this.code = code;
    this.name = name;
    this.isProctor = isProctor;
    this.offset = offset;
    this.systemName = systemName;
  }
}
